import SRC_textImg from '../assets/TEXT.png';
import SRC_logo from '../assets/Logo/Logo@3x.png';

function Nutrition() {
    return (
        <div className="w-full h-fit overflow-x-hidden flex flex-col justify-start items-center">
            <div className="w-[85%] my-12 flex flex-col justify-center items-center gap-4">
                <img className="mx-auto w-3/4 sm:w-1/4" src={SRC_textImg} alt="textImg" />
                <h1 className="font-sans text-2xl font-medium text-[#d8a051]">2026 Elevation Staff Fitness Challenge</h1>

                <div className="text-left text-black">
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">NUTRITION</h2>
                    <p className="font-sans text-base font-normal">
                        To "Abstain" is to choose discipline over distraction. For this 30-day mission, we are removing added/refined sugars and/or all grains
                        to renew our bodies and sharpen our self-control.
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">THE SUGAR PROTOCOL</h2>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>The Rule: Avoid added and refined sugars.</li>
                        <li>The "1g Rule" is in effect so if a serving contains 1 gram or less of total sugar, it is permissible.</li>
                        <li>Allowed Sweeteners: Zero-calorie options (Stevia, Monk Fruit, Xylitol, Erythritol, etc.) are allowed.</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-bold">Common Aliases to Avoid:</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>Syrups: Agave, Barley Malt, Brown Rice, Corn, Golden, Maple, Refiner's, Sorghum, and Treacle.</li>
                        <li>The "Ose" Family: Sucrose, Fructose, Dextrose, Glucose, Maltose, Saccharose, Mannose.</li>
                        <li>Cane Derivatives: Evaporated Cane Juice, Cane Crystals, Raw Sugar, Molasses, Turbinado.</li>
                        <li>Hidden Sources: Maltodextrin, Dextrin, Fruit Juice Concentrate, HFCS, Honey, Date Sugar.</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-normal">
                        <b>Watch for "Hidden" Traps:</b> Salad dressings, ketchup, flavored yogurt, coffee creamers, sauces, bacon, and lunchmeat often contain
                        hidden sugars. Read the label every time.
                    </p>
                    <hr className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">THE GRAIN-FREE PROTOCOL</h2>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>The Rule: No grains of any kind. If it comes from a stalk or a grass, it's off-limits for 30 days.</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-bold">Items to Remove/Avoid:</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>Wheat: Bread, pasta, crackers, flour, tortillas, couscous, and bulgur.</li>
                        <li>Corn: Tortillas, chips, cornmeal, popcorn, and grits.</li>
                        <li>Rice: White, brown, jasmine, basmati, and wild rice.</li>
                        <li>Other Grains: Oats (oatmeal), barley, rye, spelt, and millet.</li>
                        <li>Pseudo-Grains: Quinoa and buckwheat (often best to avoid for total simplicity).</li>
                    </ul>
                    <hr className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">WHAT CAN I EAT?</h2>
                    <p className="font-sans text-base font-normal">Focus on whole, God-given foods that fuel the "Work" pillar:</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>Proteins: Beef, poultry, fish, eggs, and pork.</li>
                        <li>Fats: Avocado, olives, nuts (in moderation), and seeds.</li>
                        <li>Produce: All vegetables and whole fruits (whole fruit is allowed; fruit juice is not unless fresh squeezed).</li>
                        <li>Dairy: Butter, hard cheeses, and plain (unsweetened) yogurt or heavy cream.</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-normal">
                        <b>Pro-Tip:</b> If the ingredient list is long and hard to pronounce, it's probably not for this mission. When in doubt, leave it out.
                    </p>
                    <br className="my-4" />
                    <p className="font-sans text-base font-normal text-center">
                        **Contact Buck at <a href="mailto:bbuhler@elevationchurch.org"><u>bbuhler@elevationchurch.org</u></a> with questions.**
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-bold text-black text-center">EVERYDAY WAR-SHIP</h2>
                    <p className="font-sans text-base font-normal text-center italic">
                        Every day is a battle. Every choice is an opportunity to worship. Let's go to W.A.R.
                    </p>
                </div>

                <img className="w-12 mt-6" src={SRC_logo} alt="logoImg" />
            </div>
        </div>
    );
}

export default Nutrition;
